export const getDefaultDomain = domainsList => {
  return Object.keys(domainsList).filter(name => {
    return domainsList[name].includes('DEFAULT');
  });
};
